import React, { Component } from "react";
import $ from "jquery";
import "../Admin/viewAdmin.css";
import Axios from "axios";
import config from "../../config/config";
import { connect } from "react-redux";
import ThemeContext from "../../context/themeContext/ThemeContext";
import { Link } from "react-router-dom";
import moment from "moment";

class FeeVouchers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adminData: [],
      modalData: null,
      name: "",
      contactNo: "",
      address: "",
      description: "",
      enabled: false,
      id: null,
      isLoading: true,
      disablepage: false,
      disableBPage: false,
      currentPage: 1,
      todosPerPage: 10,
      changeIndex: 4,
      sessions: [],
      sessionId: "",
      paymentType: "",
      paymentTypeSend: "",
      status: "",
      pages: [],
      paidBy: "",
      date: "",
      bankName: "",
      amount: "",
      chequeDiv: false,
      GraphData: {
        datasets: [
          {
            // barPercentage: 0.4,
            // minBarLength: 2,
            label: "Course Average",
            data: [2, 2, 2],
            backgroundColor: [
              "#dfeaea",
              "#ea766c",
              "#abe2b9",
              "#adbceb",
              "#be9e9d",
              "#9d5b4d",
              "#e4d86b",
              "#9ecf54",
              "#e4d86b",
              "#ea766c",
              "#abe2b9",
              "#adbceb",
            ],
            borderColor: [
              "#abe2b9",
              // '#ea766c',
              // '#adbceb',
              // '#be9e9d',
              // '#9d5b4d',
              // '#e4d86b',
              // '#9ecf54',
              // '#e4d86b'
            ],
            // borderWidth: 2
          },
        ],
        labels: ["BIO", "ICT", "MATH"],
        options: {
          showLines: true,
        },
      },
    };
  }

  static contextType = ThemeContext;

  // TODO make this code reuseable
  handleClickNextFrwd = () => {
    const { adminData, todosPerPage, count, currentPage, pages } = this.state;
    let pageNumbers = [];
    for (
      let i = 1;
      i <= Math.ceil(adminData.length / this.state.todosPerPage);
      i++
    ) {
      pageNumbers.push(i);
    }
    console.log("pagelength: ", pageNumbers.length);
    console.log("current page: ", currentPage);
    if (currentPage === pageNumbers.length) {
      this.setState({
        disablepage: true,
      });
    } else {
      this.setState((prevState) => ({
        currentPage: prevState.currentPage + 1,
        disableBPage: false,
      }));
    }
    if (currentPage > 4) {
      debugger;
      this.setState({
        changeIndex: +this.state.changeIndex + 1,
      });
    }
  };
  handleClickNext = (event) => {
    this.setState({
      currentPage: Number(event.target.id),
      disablepage: false,
      disableBPage: false,
    });
  };
  handleClickNextBack = () => {
    const { adminData, todosPerPage, count, currentPage } = this.state;
  };
  paginationRequest = (number) => {
    this.setState({
      searchCheck: true,
    });
    console.log(number);
    var token;
    if (localStorage.jwtToken) {
      token = localStorage.getItem("jwtToken");
    }
    Axios.get(
      `${config.localhttp}/api/StudentInstallmentList/?pageNumber=${number}&pageSize=20&sessionId=${this.state.sessionId}&paymentType=${this.state.paymentType}&status=${this.state.status}`,
      {
        headers: { Authorization: `Bearer  ${token}` },
      }
    )
      .then((success) => {
        console.log(success);
        debugger;
        this.setState({
          isLoading: false,
          adminData: success.data.recieptList,
          pages: success.data.paginationMetadata,
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        console.log(error);
      });
  };
  onSearchVouchers = (e) => {
    e.preventDefault();
    this.setState({
      searchCheck: true,
    });

    var token;
    if (localStorage.jwtToken) {
      token = localStorage.getItem("jwtToken");
    }
    Axios.get(
      `${config.localhttp}/api/StudentInstallmentList/?pageNumber=1&pageSize=20&sessionId=${this.state.sessionId}&paymentType=${this.state.paymentType}&status=${this.state.status}`,
      {
        headers: { Authorization: `Bearer  ${token}` },
      }
    )
      .then((success) => {
        console.log(success);
        debugger;
        this.setState({
          isLoading: false,
          adminData: success.data.recieptList,
          pages: success.data.paginationMetadata,
        });
      })
      .catch((error) => {
        this.setState({
          adminData: [],
          isLoading: false,
          pages: [],
        });
        console.log(error);
      });
  };
  handleClickNext = (event) => {
    this.setState({
      currentPage: Number(event.target.id),
      disablepage: false,
      disableBPage: false,
    });
  };
  handleClickNextBack = () => {
    const { adminData, todosPerPage, count, currentPage } = this.state;

    console.log("current page: ", currentPage);
    if (currentPage === 1) {
      this.setState({
        disableBPage: true,
        disablepage: false,
      });
    } else {
      this.setState((prevState) => ({
        changeIndex: +this.state.changeIndex - 1,
        currentPage: prevState.currentPage - 1,
      }));
    }
  };
  componentDidMount() {
    let token = "";
    if (localStorage.jwtToken) {
      token = localStorage.getItem("jwtToken");
    }
    Axios.get(
      `${config.localhttp}/api/StudentInstallmentList/?pageNumber=1&pageSize=20&sessionId=&paymentType=&status=`,
      {
        headers: { Authorization: `Bearer  ${token}` },
      }
    )
      .then((success) => {
        console.log(success);
        debugger;
        this.setState({
          isLoading: false,
          adminData: success.data.recieptList,
          pages: success.data.paginationMetadata,
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        console.log(error);
      });

    Axios.get(`${config.localhttp}/api/Session`, {
      headers: { Authorization: `Bearer  ${token}` },
    })
      .then((success) => {
        console.log("Sessions Success", success);
        this.setState({
          sessions: success.data.session,
        });
      })
      .catch((error) => {});
  }
  btnTechHover = () => {
    $(document).ready(function () {
      $("button").hover(
        function () {
          $(this).css("box-shadow", "0px 5px 5px grey");
          $(this).css("border-color", "white");
        },
        function () {
          $(this).css("box-shadow", "0px 0px 0px white");
        }
      );
    });
  };
  onTakeItemDelete = (itemId) => {
    this.setState({
      modalData: [],
    });
    console.log(itemId);

    const { adminData } = this.state;
    let token = "";
    if (localStorage.jwtToken) {
      token = localStorage.getItem("jwtToken");
    }
    var Headconfig = {
      headers: { Authorization: "Bearer " + token },
    };
    var bodyParameters = { id: itemId };

    Axios.delete(`${config.localhttp}/api/Suppliers/${itemId}`, {
      data: { id: itemId }, // or data: jdId, depending on how you handle it in the back end
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        console.log(response);
        if (response.status == 200) {
          let getData = adminData.filter((item) => item.id !== itemId);

          this.setState({
            adminData: getData,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  onTakeItem = (itemId) => {
    this.setState({
      modalData: [],
    });
    const { adminData } = this.state;
    let getData = adminData.filter((item) => item.id === itemId);

    this.setState({
      modalData: getData,
      name: getData[0].name,
      description: getData[0].description,
      address: getData[0].address,
      contactNo: getData[0].contactNo,
      id: getData[0].id,
    });
  };
  onHandleText = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  onHandleTextDate = (e) => {
    let Date1 = moment(e.target.value).format("MM/DD/YYYY");
    this.setState({
      [e.target.name]: Date1,
    });
  };
  onHandleTextPayment = (e) => {
    if (e.target.value === "Cheque") {
      this.setState({
        chequeDiv: true,
        [e.target.name]: e.target.value,
      });
    } else {
      debugger;
      this.setState({
        chequeDiv: false,
        [e.target.name]: e.target.value,
      });
    }
  };
  onHandleSubmit = (e) => {
    e.preventDefault();
    const { paymentTypeSend , paidBy , chequeNo , date , bankName , amount , id, } = this.state;
    let token = "";
    if (localStorage.jwtToken) {
      token = localStorage.getItem("jwtToken");
    }
    var Headconfig = {
      headers: { Authorization: "Bearer " + token },
    };
    var bodyParameters = {
      id,
      bankName,
      date,
      chequeNo,
      feesPaidBy : paidBy,
      paymentMethod: paymentTypeSend,
      amount,
      // date: new Date().toDateString(),
      // time: new Date().toLocaleTimeString(),
      // accountId: this.props.data.unique_name,
      // accountType: this.props.data.role,
    };

    Axios.patch(
      `${config.localhttp}/api/feeDuesVoucher/?id=${id}`,
      bodyParameters,
      Headconfig
    )
      .then((response) => {
        console.log(response);
        debugger;
        if (response.status == 200) {
          var admindata = [...this.state.adminData];
          var index = admindata.findIndex((obj) => obj.id === id);
          admindata[index].status = "Paid";
          this.setState({ adminData: admindata });
          $("#myModal").modal("hide");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  onEditClick = (itemId) => {
    // this.onTakeItem(itemId);
    this.setState({ id: itemId });
  };

  PrintContent = (el) => {
    var restorepage = document.body.innerHTML;
    var Printcontent = document.getElementById(el).innerHTML;
    document.body.innerHTML = Printcontent;
    window.print();
    document.body.innerHTML = restorepage;
    window.location.reload();
  };

  render() {
    const { adminData, modalData, sessions, pages } = this.state;
    console.log("admin data: ", this.state.adminData);
    const Loader = (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div class="spinner-border" style={{ color: "#01AC8A" }}></div>
      </div>
    );
    let pageNumbers = [];
    for (let i = 1; i <= Math.ceil(pages.totalCount / pages.pageSize); i++) {
      pageNumbers.push(i);
    }
    const renderPageNumbers = pageNumbers.map((number) => {
      return (
        <ThemeContext.Consumer>
          {(context) => (
            <li class={`page-item `}>
              <a
                key={number}
                id={number}
                onClick={() => this.paginationRequest(number)}
                class="page-link"
                href="#"
                style={{
                  background: `${
                    pages.currentPage === number
                      ? context.themeColors.primaryColor
                      : ""
                  }`,
                  color: `${
                    pages.currentPage === number
                      ? "#fff"
                      : context.themeColors.primaryColor
                  }`,
                }}
              >
                {number}
              </a>
            </li>
          )}
        </ThemeContext.Consumer>
      );
    });
    const { currentPage, todosPerPage } = this.state;
    const indexOfLastTodo = currentPage * todosPerPage;
    const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
    // const currentTodos = adminData.slice(indexOfFirstTodo, indexOfLastTodo);
    const renderTodos = adminData.map((item, index) => {
      return (
        <tr key={index}>
          <th scope="row">{index + 1}</th>
          <td>{item.student}</td>
          <td>{item.paymentType}</td>
          <td>{item.installmentAmount}</td>
          <td>{item.month}</td>
          <td>{item.status}</td>
          <td className="no-print">
            <Link
              to={`/dashboard/VoucherDetails/${item.paymentType}/${item.classId}/${item.studentId}/${item.sessionId}`}
            >
              <button
                id="firstbutton"
                onMouseOver={this.btnTechHover()}
                style={{
                  cursor: "pointer",
                  fontSize: 20,
                  border: "none",
                  marginLeft: 5,
                  background: "none",
                  marginBottom: 5,
                }}
              >
                <i class="fas fa-list"></i>
              </button>
            </Link>
            <button
              data-toggle="modal"
              data-target="#myModal"
              onClick={() => this.onEditClick(item.id)}
              disabled={item.status == "Paid" ? true : false}
              className="btn btn-warning btn-sm"
            >
              Pay
            </button>
          </td>
        </tr>
      );
    });
    const MainContent = (
      <div>
        <div class="modal" id="myModal1">
          <div class="modal-dialog">
            <div class="modal-content modal_content_custom">
              <div
                style={{
                  background: this.context.themeColors.primaryColor,
                  borderBottomLeftRadius: 30,
                  borderBottomRightRadius: 30,
                  borderTopLeftRadius: 18,
                  borderTopRightRadius: 18,
                }}
                class="modal-header modal_custom_header"
              >
                <h4 style={{ color: "white" }} class="modal-title">
                  Confirm
                </h4>
                <button
                  style={{ color: "white" }}
                  type="button"
                  class="close"
                  data-dismiss="modal"
                >
                  &times;
                </button>
              </div>
              <div class="modal-body">
                {modalData &&
                  modalData.map((item, index) => (
                    <div key={index}>
                      <div style={{ textAlign: "center" }}>
                        <h4>Are you sure ?</h4>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <div>
                          <button
                            disabled={this.state.enabled}
                            data-dismiss="modal"
                            onClick={() => this.onTakeItemDelete(this.state.id)}
                            type="button"
                            class="btn btn-primary buttonAppear"
                          >
                            Yes
                          </button>
                        </div>
                        <div>
                          <button
                            data-dismiss="modal"
                            disabled={this.state.enabled}
                            type="button"
                            class="btn btn-primary buttonAppear"
                          >
                            No
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
        <div class="modal" id="myModal">
          <div class="modal-dialog">
            <div class="modal-content modal_content_custom">
              <div
                style={{
                  background: this.context.themeColors.primaryColor,
                  borderBottomLeftRadius: 30,
                  borderBottomRightRadius: 30,
                  borderTopLeftRadius: 18,
                  borderTopRightRadius: 18,
                }}
                class="modal-header modal_custom_header"
              >
                <h4 style={{ color: "white" }} class="modal-title">
                  Details
                </h4>
                <button
                  style={{ color: "white" }}
                  type="button"
                  class="close"
                  data-dismiss="modal"
                >
                  &times;
                </button>
              </div>
              <div class="modal-body">
                <form onSubmit={this.onHandleSubmit}>
                  <div>
                    <fieldset disabled={false}>
                      <div class="form-group">
                        <label for="name">Fees Paid By:</label>
                        <input
                          style={{
                            borderTop: 0,
                            borderLeft: 0,
                            borderRight: 0,
                            boxShadow: "none",
                          }}
                          type="text"
                          value={this.state.paidBy}
                          onChange={this.onHandleText}
                          name="paidBy"
                          class="form-control"
                          id="name"
                        />
                      </div>
                      <div class="form-group">
                        <label for="description">Payment Type:</label>
                        <select
                          onChange={this.onHandleTextPayment}
                          class="custom-select"
                          name="paymentTypeSend"
                        >
                          <option>Payment Type</option>
                          <option value="Card">Card</option>
                          <option value="Cash">Cash</option>
                          <option value="Cheque">Cheque</option>
                        </select>
                      </div>
                      {this.state.chequeDiv ? (
                        <React.Fragment>
                          <div class="form-group">
                            <label for="address">Cheque No:</label>
                            <input
                              required
                              style={{
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                boxShadow: "none",
                              }}
                              value={this.state.chequeNo}
                              onChange={this.onHandleText}
                              type="text"
                              name="chequeNo"
                              class="form-control"
                              id="address"
                            />
                          </div>
                          <div class="form-group">
                            <label for="address">Bank Name:</label>
                            <input
                              required
                              style={{
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                boxShadow: "none",
                              }}
                              value={this.state.bankName}
                              onChange={this.onHandleText}
                              type="text"
                              name="bankName"
                              class="form-control"
                              id="address"
                            />
                          </div>
                          <div class="form-group">
                            <label for="address">Amount:</label>
                            <input
                              required
                              style={{
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                boxShadow: "none",
                              }}
                              value={this.state.amount}
                              onChange={this.onHandleText}
                              type="text"
                              name="amount"
                              class="form-control"
                              id="address"
                            />
                          </div>
                          <div class="form-group">
                            <label for="description">Date:</label>
                            <input
                              required
                              style={{
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                boxShadow: "none",
                              }}
                              // value={this.state.date}
                              onChange={this.onHandleTextDate}
                              type="date"
                              name="date"
                              class="form-control"
                              id="description"
                            />
                          </div>
                        </React.Fragment>
                      ) : null}
                    </fieldset>
                    {/* <button
                      disabled={this.state.enabled}
                      onClick={() =>
                        this.setState({ enabled: true, password: "" })
                      }
                      type="button"
                      class="btn btn-primary buttonAppear"
                    >
                      Edit
                    </button> */}
                    <button
                      style={{ marginLeft: 5 }}
                      // disabled={!this.state.enabled}
                      type="submit"
                      class="btn btn-primary"
                    >
                      Update
                    </button>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  style={{ background: "#00435D" }}
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <img
            src={require("../../Assets/images/header.png")}
            style={{
              width: "100%",
              height: "150",
            }}
          />
        </div>
        <div className="table-responsive">
          <ThemeContext.Consumer>
            {(context) => (
              <table
                class="table table-hover table-bordered"
                style={{ textAlign: "center" }}
              >
                <thead
                  style={{
                    background: context.themeColors.primaryColor,
                    color: "white",
                  }}
                >
                  <tr className="vendorListHeading">
                    <th scope="col">#</th>
                    <th scope="col">Student Name</th>
                    <th scope="col">Payment Type</th>
                    <th scope="col">Installment</th>
                    <th scope="col">Month</th>
                    <th scope="col">Status</th>
                    <th scope="col" className="no-print">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>{renderTodos}</tbody>
              </table>
            )}
          </ThemeContext.Consumer>
        </div>
      </div>
    );
    return (
      <div>
        <div id="div1">
          <div className="page-header">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h2
                  style={{ background: this.context.themeColors.primaryColor }}
                  className="h1-responsive font-weight-bold text-center  generalHead"
                >
                  Fee Vouchers
                </h2>
              </div>
              <nav aria-label="Page navigation example" className="no-print">
                <ul
                  style={{ color: this.context.themeColors.primaryColor }}
                  class="pagination"
                >
                  {/* <li
                    class={`page-item ${
                      this.state.disableBPage ? "disabled" : ""
                    }`}
                  >
                    <a
                      onClick={this.handleClickNextBack}
                      class="page-link"
                      href="#"
                    >
                      {this.state.disableBPage ? (
                        <i
                          style={{ color: "grey" }}
                          class="far fa-stop-circle"
                        ></i>
                      ) : (
                        <i
                          style={{ color: "grey" }}
                          class="fas fa-backward"
                        ></i>
                      )}
                    </a>
                  </li> */}
                  {renderPageNumbers}
                  {/* <li
                    class={`page-item ${
                      this.state.disablepage ? "disabled" : ""
                    }`}
                  >
                    <a
                      onClick={this.handleClickNextFrwd}
                      class="page-link"
                      href="#"
                    >
                      {this.state.disablepage ? (
                        <i
                          style={{ color: "grey" }}
                          class="far fa-stop-circle"
                        ></i>
                      ) : (
                        <i style={{ color: "grey" }} class="fas fa-forward"></i>
                      )}
                    </a>
                  </li> */}
                </ul>
              </nav>
            </div>
          </div>
          {/* <div className="row justify-content-between no-print">
            <div className="col-md-3"></div>
            <div class="col-md-2">
              <div class="md-form mb-0">
                <label for="email" class="">
                  Entries
                </label>
                <select
                  onChange={(e) =>
                    this.setState({
                      todosPerPage: e.target.value,
                    })
                  }
                  class="custom-select"
                  name="CategoryName"
                >
                  <option selected={this.state.msg ? true : false} value="10">
                    {" "}
                    Select Entries
                  </option>
                  <option value={this.state.adminData.length}>
                    All Entries
                  </option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="40">40</option>
                  <option value="50">50</option>
                  ))
                </select>
              </div>
            </div>
          </div> */}
          <div className="row justify-content-center no-print mt-4">
            <div className="col-md-3">
              <div class="md-form mb-0">
                <select
                  onChange={(e) => this.setState({ sessionId: e.target.value })}
                  class="custom-select"
                >
                  <option selected={this.state.msg ? true : false} value="">
                    Select Session
                  </option>
                  {sessions &&
                    sessions.map((item, index) => (
                      <option key={index} value={`${item.sessionId}`}>
                        {item.currentSession}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-md-3">
              <div class="md-form mb-0">
                {/* <label for="email" class="">
                  Payment Type
                </label> */}
                <select
                  onChange={(e) =>
                    this.setState({
                      paymentType: e.target.value,
                    })
                  }
                  class="custom-select"
                >
                  <option selected={this.state.msg ? true : false} value="">
                    {" "}
                    Select Payment Type
                  </option>
                  <option value="Full Payment">Full Payment</option>
                  <option value="1st Installment">1st Installment</option>
                  <option value="2nd Installment">2nd Installment</option>
                  <option value="3rd Installment">3rd Installment</option>
                  <option value="4th Installment">4th Installment</option>
                  ))
                </select>
              </div>
            </div>
            <div className="col-md-3">
              <div class="md-form mb-0">
                {/* <label for="email" class="">
                  Status
                </label> */}
                <select
                  onChange={(e) =>
                    this.setState({
                      status: e.target.value,
                    })
                  }
                  class="custom-select"
                >
                  <option selected={this.state.msg ? true : false} value="">
                    {" "}
                    Select Status
                  </option>
                  <option value="Paid">Paid</option>
                  <option value="Not Paid">Not Paid</option>
                  ))
                </select>
              </div>
            </div>
            <div class="col-md-12 text-center mt-4 mb-2">
              <button
                type="submit"
                // disabled={
                //   classId !== "" &&
                //   sessionId !== "" &&
                //   sectionId !== "" &&
                //   term !== "" &&
                //   subjectId !== ""
                //     ? false
                //     : true
                // }
                style={{
                  backgroundColor: this.context.themeColors.primaryColor,
                  border: "none",
                  fontSize: 20,
                  borderRadius: 4,
                  color: "white",
                }}
                onClick={this.onSearchVouchers}
              >
                Search
                <i
                  style={{ color: "white", marginLeft: 4 }}
                  class="fas fa-search"
                ></i>
                <span
                  style={{ marginBottom: 5 }}
                  class={`${
                    this.state.btnLoad ? "spinner-border spinner-border-sm" : ""
                  }`}
                ></span>
              </button>
            </div>
          </div>
          {this.state.isLoading ? Loader : MainContent}
          <div class="page-footer">
            <div class="text-left">Printed By: {this.props.data.role}</div>
            <div class="text-right" style={{ marginTop: -25, marginRight: 20 }}>
              Powered by School Smart®
            </div>
          </div>
        </div>
        <div
          class="text-center text-md-right displayElemet"
          style={{ marginBottom: 10 }}
        >
          <label for="name" class="" onClick={() => this.PrintContent("div1")}>
            <i
              className="fas fa-print fa-2x animated fadeIn"
              style={{ marginRight: 4 }}
            />
            Print
          </label>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    data: state.setUserReducer.users,
  };
}
export default connect(mapStateToProps, null)(FeeVouchers);
